import { DqStatCard, SectionTitle, STAT_CARD_GRID_4_SX } from '../gamification-dash/dqShared';
import { Box } from '@mui/material';
import { formatMonthLabel } from './messagesUtils';

const MessagesSummarySection = ({ summary, periodLoading, startMonth, endMonth }) => {
  const periodLabel =
    startMonth === endMonth
      ? formatMonthLabel(startMonth)
      : `${formatMonthLabel(startMonth)} – ${formatMonthLabel(endMonth)}`;
  const periodDataReady = !periodLoading && summary?.periodTotal != null;
  const displayPeriodValue = (value) => (periodDataReady ? (value ?? 0) : '…');

  return (
    <Box>
      <SectionTitle>Messages Overview</SectionTitle>
      <Box sx={STAT_CARD_GRID_4_SX}>
        <DqStatCard
          title="Total Messages (All Time)"
          value={summary?.totalAllTime == null ? '…' : (summary?.totalAllTime ?? 0)}
          subtitle="All users"
        />
        <DqStatCard
          title="Messages in Period"
          value={displayPeriodValue(summary?.periodTotal)}
          subtitle={`${periodLabel} · All users`}
        />
        <DqStatCard
          title="User Messages"
          value={displayPeriodValue(summary?.userMessages)}
          subtitle={`${periodLabel} · All users`}
        />
        <DqStatCard
          title="Follow-up Messages"
          value={displayPeriodValue(summary?.followUpMessages)}
          subtitle={`${periodLabel} · Registered only`}
        />
      </Box>
    </Box>
  );
};

export default MessagesSummarySection;
